import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { IAppState } from 'src/store';

const Tag: React.FC<Props> = ({
  children,
  className,
  size = 'is-normal',
  variant = 'is-primary',
  isLight = false,
  ...props
}) => {
  return (
    <span className={cn('tag', variant, size, { 'is-light': isLight })} {...props}>
      {children}
    </span>
  );
};

export type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
    variant?:
      | 'is-black'
      | 'is-dark'
      | 'is-light'
      | 'is-white'
      | 'is-primary'
      | 'is-link'
      | 'is-info'
      | 'is-success'
      | 'is-warning'
      | 'is-danger'
      | 'is-secondary'
      | 'is-gray';
    isLight?: boolean;
    size?: 'is-normal' | 'is-medium' | 'is-large';
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Tag);
